import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Axios from "axios";

export const getReportes = createAsyncThunk(
    'conta/getReportes',
    async (configObj) => {
        const info = configObj.params
        const response = await Axios(configObj)
        return  {response: response.data, info: info}   
    }
)

export const getBatches = createAsyncThunk(
    'conta/getBatches',
    async (configObj) => {
        const info = configObj.params
        const response = await Axios(configObj)
        return { response: response.data, info: info }
    }
)

/*export const getBoletasCirculantes = createAsyncThunk(
    'conta/getBoletasCirculantes',
    async (configObj) => {
        const info = configObj.params
        const response = await Axios(configObj)
        return { response: response.data, info: info }
    }
)*/
console.log(getReportes)
console.log([getReportes])
const contaSlice = createSlice({
    name: 'conta',
    initialState : {
        reportes: [], 
        reportes_LastMonth: [], 
        ApiResponse: '', 
        info: '', 
        resumen:'', 
        ShowResumen: false, 
        batches: [], 
        InfoBatches: '', 
        BatchesApiResponse: '',
        detalles: {
            bancos: {
                data: [],
                info: '',
            },
            boletas: {
                data: [],
                info: '',
            },
            efectivo: {
                data: [],
                info: '',
            },
        },
        ISC: [],
    },
    reducers: {
        setReportes_LastMonth: (state, action) => {
            state.reportes_LastMonth = action.payload
        },
        setResumen: (state, action) => {
            state.resumen = action.payload
            state.ShowResumen = true
        },
        hideResumen: (state) => {
            state.resumen = ''
            state.ShowResumen = false
        },
        setDetallesBancos: (state, action) => {
            state.detalles.bancos.data = action.payload.data
            state.detalles.bancos.info = action.payload.info
        },
        setDetallesBoletas: (state, action) => {
            state.detalles.boletas.data = action.payload.data
            state.detalles.boletas.info = action.payload.info
        },
        setDetallesEfectivo: (state, action) => {
            state.detalles.efectivo.data = action.payload.data
            state.detalles.efectivo.info = action.payload.info
        },
        setISC: (state, action) => {
            state.ISC = action.payload
        }
    },
    extraReducers: {
        
        [getReportes.pending]: (state, action) => {
            state.ApiResponse = 'pending'
        },
        [getReportes.fulfilled]: (state, action) => {
            state.reportes = action.payload.response
            state.info = action.payload.info
            state.showResumen = action.payload.showResumen
            state.ApiResponse = 'succeed'
        },
        [getReportes.rejected]: (state, action) => {
            state.ApiResponse = 'rejected'
        },

        [getBatches.pending]: (state) => {
            state.BatchesApiResponse = 'pending'
        },
        [getBatches.fulfilled]: (state, action) => {
            state.batches = action.payload.response
            state.InfoBatches = action.payload.info
            state.BatchesApiResponse = 'succeed'
        },
        [getBatches.rejected]: (state) => {
            state.BatchesApiResponse = 'rejected'
        },

        /*[getBoletasCirculantes.pending]: (state) => {
            state.BoletasApiResponse = 'pending'
        },
        [getBoletasCirculantes.fulfilled]: (state, action) => {
            state.boletas = action.payload.response
            state.InfoBoletas = action.payload.info
            state.BoletasApiResponse = 'succeed'
        },
        [getBoletasCirculantes.rejected]: (state) => {
            state.BoletasApiResponse = 'rejected'
        },*/
    },
})

export const { 
    setReportes_LastMonth, 
    setResumen, 
    hideResumen, 
    setDetallesBancos,
    setDetallesBoletas,
    setDetallesEfectivo, 
    setISC,
} = contaSlice.actions
export default contaSlice.reducer